module.exports = __webpack_public_path__ + "static/img/img-checkin-success.499d7ac6.jpg";